/*
 * @Description: 个人中心
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const ProfileRouter: Array<RouteRecordRaw> = [
  {
    path: '/profile',
    component: Layout,
    // redirect: '/profile/index',
    redirect: 'noredirect',
    meta: { hidden: true },
    children: [
      {
        path: 'user-info',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/profile//user-info/Index.vue'),
        name: 'UserInfo',
        meta: {
          title: 'userInfo',
          icon: 'user',
          noCache: true
        }
      },
      {
        path: 'reset-password',
        component: () => import(/* webpackChunkName: "resetPassword" */ '@/views/profile/reset-password/Index.vue'),
        name: 'ResetPassword',
        meta: {
          title: 'resetPassword',
          icon: 'user',
          noCache: true
        }
      },
      {
        path: 'set-mfa',
        component: () => import(/* webpackChunkName: "setMFA" */ '@/views/profile/set-mfa/Index.vue'),
        name: 'SetMFA',
        meta: {
          title: 'mfaBind',
          icon: 'user',
          noCache: true
        }
      }
    ]
  }
]

export default ProfileRouter
